/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePatientDto
 */
export interface UpdatePatientDto {
    /**
     * 
     * @type {string}
     * @memberof UpdatePatientDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePatientDto
     */
    email?: string;
    /**
     * ISO date string
     * @type {string}
     * @memberof UpdatePatientDto
     */
    dateOfBirth?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePatientDto
     */
    gender?: UpdatePatientDtoGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdatePatientDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePatientDto
     */
    address?: string;
}


/**
 * @export
 */
export const UpdatePatientDtoGenderEnum = {
    Male: 'male',
    Female: 'female'
} as const;
export type UpdatePatientDtoGenderEnum = typeof UpdatePatientDtoGenderEnum[keyof typeof UpdatePatientDtoGenderEnum];


/**
 * Check if a given object implements the UpdatePatientDto interface.
 */
export function instanceOfUpdatePatientDto(value: object): value is UpdatePatientDto {
    return true;
}

export function UpdatePatientDtoFromJSON(json: any): UpdatePatientDto {
    return UpdatePatientDtoFromJSONTyped(json, false);
}

export function UpdatePatientDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePatientDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : json['dateOfBirth'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'address': json['address'] == null ? undefined : json['address'],
    };
}

export function UpdatePatientDtoToJSON(json: any): UpdatePatientDto {
    return UpdatePatientDtoToJSONTyped(json, false);
}

export function UpdatePatientDtoToJSONTyped(value?: UpdatePatientDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'email': value['email'],
        'dateOfBirth': value['dateOfBirth'],
        'gender': value['gender'],
        'phone': value['phone'],
        'address': value['address'],
    };
}

